<template>
	<div>
		<div class="relative banner-container d-flex flex-column">
			<Cover :class="!isXS ? 'rounded-t-4' : ''" :src="cover" width="100%" height="100%" />
			<div class="absolute top-0 height-full align-content-center pl-6">
				<h3 class="text-neutral-25 mt-20" :class="isXS ? 'text-title-s' : 'text-title-m'">
					{{ $t('profileCreationSetup_heading') }}
				</h3>
				<p class="mt-2 text-body-xl text-neutral-25">
					{{ $t('profileCreationSetup_subheading') }}
				</p>
			</div>
		</div>
		<ProfileForm
			class="px-6"
			:profile="profile"
			:form-errors="formErrors"
			is-creating
			@change="(value) => $emit('change', value)"
		/>
	</div>
</template>
<script lang="ts" setup>
	import cover from '~/assets/profileWizard/profile-wizard-form.png'
	import { Profile } from '~/models/Profile'
	interface Props {
		profile: Profile
		formErrors: Partial<Record<keyof Profile, string>>
		isXS: boolean
	}
	defineProps<Props>()
	defineEmits(['change'])
</script>
<style lang="scss" scoped>
	.banner-container {
		height: 250px;
	}
</style>
